import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { configGetEnv } from 'common/helper/config/get-env';
import { DropdownViewStore } from 'common/module/dropdown/view-store';

export function DropdownViewStoreFactory(): DropdownViewStore {
  return new DropdownViewStore(EventEmitterFactory(), WindowService(), configGetEnv());
}
